import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'seo-suppliers_page_visual_nav_carousel_mobile_scroll-action_unknown';

/**
 * to track mobile scrolling of header carousel on the suppliers page
 */
export function trackSeoSuppliersPageVisualNavCarouselMobileScroll(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
